export const MONEYBLOX_WALLET_BALANCE = "MONEYBLOX_WALLET_BALANCE";
export const MONEYBLOX_WALLET_USER_DETAILS = "MONEYBLOX_WALLET_USER_DETAILS";
export const MONEYBLOX_WALLET_MODAL_SHOW = "MONEYBLOX_WALLET_MODAL_SHOW";
export const MONEYBLOX_WALLET_MODAL_HIDE = "MONEYBLOX_WALLET_MODAL_HIDE";